var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDotgovUploadDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1553_4300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5008 140.002C109.161 140.002 140.502 108.661 140.502 70.0008C140.502 31.3404 109.161 0 70.5008 0C31.8404 0 0.5 31.3404 0.5 70.0008C0.5 108.661 31.8404 140.002 70.5008 140.002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.063 77.6199C136.265 112.693 106.558 139.995 70.4744 139.995C66.3288 139.997 62.1911 139.633 58.1096 138.907L46.2512 127.048H46.243L33.9603 114.785V103.274L30.8358 101.629L25.0801 95.7092L32.8092 78.8812L110.375 47.636L140.063 77.6199Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9967 20.7485H70.4992V119.582H43.9967C40.5586 119.582 37.2612 118.216 34.8301 115.785C32.399 113.354 31.0332 110.057 31.0332 106.619V33.712C31.0332 30.2739 32.399 26.9766 34.8301 24.5455C37.2612 22.1143 40.5586 20.7485 43.9967 20.7485Z",
    fill: "#D5341C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.969 47.6704V106.617C109.969 110.056 108.603 113.353 106.171 115.785C103.74 118.216 100.442 119.582 97.0034 119.582H70.5009V20.7485H83.0466L109.969 47.6704Z",
    fill: "#B72913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.125 20.7485V48.4844H110.863L83.125 20.7485Z",
    fill: "#821D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1162 59.5303H109.419C111.687 59.5303 113.862 60.4312 115.466 62.0349C117.07 63.6386 117.971 65.8136 117.971 68.0816V88.8021C117.971 91.0701 117.07 93.2451 115.466 94.8488C113.862 96.4525 111.687 97.3534 109.419 97.3534H70.1162V59.5303Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1719 97.3535H30.8687C28.6007 97.3535 26.4257 96.4526 24.822 94.8489C23.2183 93.2452 22.3173 91.0701 22.3173 88.8022L22.3173 68.0817C22.3173 65.8137 23.2183 63.6387 24.822 62.035C26.4257 60.4313 28.6007 59.5303 30.8687 59.5303L70.1719 59.5303V97.3535Z",
    fill: "#F4F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5832 69.8757L55.478 69.8625H49.0645V87.8977H52.6823V81.5927H54.7412H54.8925C56.396 81.5885 57.8417 81.0138 58.9379 79.9849C60.034 78.9559 60.6987 77.5493 60.7979 76.0491C60.8769 74.5499 60.3816 73.0769 59.4128 71.93C58.444 70.7831 57.0746 70.0485 55.5832 69.8757ZM57.1833 75.8452C57.1448 76.438 56.8771 76.9925 56.437 77.3915C55.9969 77.7905 55.4188 78.0026 54.8251 77.983H52.6873V73.4804H55.2527C55.8072 73.5715 56.3092 73.8622 56.6642 74.2978C57.0193 74.7334 57.2027 75.2837 57.18 75.8452H57.1833Z",
    fill: "#821D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1723 73.487V69.8691H64.5811V87.8976H68.1989H70.1723V84.2798H68.1989V73.487H70.1723Z",
    fill: "#821D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2211 69.8904L71.0566 69.8608H70.1719V73.4787H70.7047C72.1009 73.852 74.0216 76.2184 73.9114 79.1933C73.8522 80.8378 73.1583 82.4264 72.0548 83.4394C71.4611 83.9886 70.8182 84.2896 70.2903 84.2616H70.1719V87.8795H70.3511C71.7851 87.8795 73.2504 87.2529 74.5035 86.0985C76.3025 84.4441 77.4323 81.9083 77.5277 79.3166C77.6921 74.8667 74.8044 70.5482 71.2211 69.8904Z",
    fill: "#821D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7927 73.4804V76.9338H90.6719V80.5517H85.7927V87.8977H82.1748V69.8625H91.3839V73.4804H85.7927Z",
    fill: "#821D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1553_4300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotgovUploadDocumentIcon);
export default __webpack_public_path__ + "static/media/dotgov-upload-document-icon.6db58524bd63589348a1ff88070c5528.svg";
export { ForwardRef as ReactComponent };